import { ReactNode } from 'react';
import { AuthenticationContext } from 'contexts';
import { useAuthenticate } from 'hooks';

export function Auth0ContextProvider({ children }: { children?: ReactNode }) {
  // eslint-disable-next-line no-restricted-syntax
  const authenticationState = useAuthenticate();

  return <AuthenticationContext.Provider value={authenticationState}>{children}</AuthenticationContext.Provider>;
}
